import(/* webpackMode: "eager" */ "/codebuild/output/src2449442634/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
